import { TreeOfNodes } from "@asup/tree-of-nodes";
import { useContext } from "react";
import { HierarchyBrowserContext } from "./HierarchyBrowserContext";
import { HierarchyNodeData, SET_CURRENT_HIERARCHY } from "./interface";

/**
 * Left-hand side of the hierarchy browser showing the directory tree.
 */
export const HierarchyBrowserLhs = () => {
  const hbc = useContext(HierarchyBrowserContext);

  return (
    hbc && (
      <div
        id={`${hbc.state.id}-left`}
        className="hb-left"
      >
        <h5>Directory</h5>
        <div className="hb-container small-scrollbar">
          <TreeOfNodes<HierarchyNodeData>
            id="hierarchy-tree"
            roots={[hbc.state.root]}
            selected={hbc.state.currentHierarchy}
            nodeList={hbc.state.treeList}
            canRemoveRoot={false}
            canAddChildren={false}
            canRenameRoot={false}
            canRemoveChildren={false}
            canRenameChildren={false}
            nodeHighlight="rgb(33,35,241)"
            textHighlight="rgba(33,35,211,0.1)"
            handleSelect={(ret) => {
              /* istanbul ignore else */
              if (!Array.isArray(ret) && typeof ret === "string") {
                hbc.dispatch({
                  operation: SET_CURRENT_HIERARCHY,
                  nodeId: ret,
                });
              }
            }}
          />
        </div>
      </div>
    )
  );
};

HierarchyBrowserLhs.displayName = "HierarchyBrowserLhs";
